import React from "react";

import "./GroupBy.scss";

const GroupBy = ({ groupBy, setGroupBy }) => {
  const handleChange = (event) => {
    setGroupBy(event.target.value);
  };

  return (
    <div className="group-by">
      <span className="group-by__label">
        Группировать по
      </span>

      <select
        className="group-by__select"
        value={groupBy}
        onChange={handleChange}
      >
        <option value="day">По дням</option>
        <option value="week">По неделям</option>
        <option value="month">По месяцам</option>
      </select>
    </div>
  );
};

export default GroupBy;